import {
  useQuoteActionsContext,
  useQuoteContext,
} from '../../services/quote/QuoteProvider';

export const useQuote = () => {
  const {quote, loading} = useQuoteContext();
  return {
    quote,
    loading,
  };
};

export const useQuoteActions = () => {
  const {
    create,
    remove,
    patch,
    fetchQuote,
    createQuoteField,
    deleteQuoteField,
  } = useQuoteActionsContext();
  return {
    create,
    remove,
    patch,
    fetchQuote,
    createQuoteField,
    deleteQuoteField,
  };
};
